import RenderInfo from 'components/RenderInfo';
import React from 'react';
import { DEFAULT_PLACEHOLDER, timeToString } from 'utils';
import styles from './index.module.scss';

const BasicDetails = (props) => {
  const { details: { name = '', enName = '', description = '', enDescription = '', preparationTime = '', cookingTime = '',
    difficultyLevel = '', nutritionValue = '', slug = '', enSlug = '', objectId = '', image: { url: imageUrl = DEFAULT_PLACEHOLDER } = {} } = {} } = props;

  return <div className={styles['details-section']}>
    <img src={imageUrl} className={styles['product-image']} />
    <div className={styles['info-container']}>
      <div className={styles['info']}>
        <RenderInfo heading="ID" value={objectId} />
        <RenderInfo heading="Name" value={name} />
        <RenderInfo heading="Description" value={description} />
        <RenderInfo heading="Preparation Time" value={preparationTime ? timeToString(preparationTime) : ''} />
        <RenderInfo heading="Cooking Time" value={cookingTime ? timeToString(cookingTime) : ''} />
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="English Name" value={enName} />
        <RenderInfo heading="English Description" value={enDescription} />
        <RenderInfo heading="Slug" value={slug} />
        <RenderInfo heading="English Slug" value={enSlug} />
        <RenderInfo heading="Difficulty Level" value={difficultyLevel} />
        <RenderInfo heading="Nutrition Value" value={nutritionValue ? `${nutritionValue}kcal` : ''} />
      </div>
    </div>
  </div>;
};

export default BasicDetails;